export default __webpack_public_path__ + "static/media/banner-assédio .27873712.jpg";